import { useState, Fragment } from 'react';
import ProjectsInfo from '../../Data';
import ProjectItem from './ProjectItem';


export default function Projects() {
  
  const [projectsData] = useState(ProjectsInfo);

  return (
      <Fragment>
              <div className="mt-6 grid grid-cols-1 gap-y-10 gap-x-6 sm:grid-cols-2 xl:grid-cols-3 xl:gap-x-8">
                {projectsData.map((item) => (
                  <ProjectItem 
                    key={item.id}
                    title={item.name}
                    introdesc={item.introdesc}
                    imgViewMore={item.imgViewMore}
                    desc={item.desc}
                    img={item.imgUrl}
                    imgAlt={item.imgAlt}
                    viewDemo={item.viewDemo}
                    id={item.id}
                  />
                ))}
              </div>
      </Fragment>
  );
}